import { t } from "i18next";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Row, Col, Input, Label } from "reactstrap";
import { useState } from "react";
import DefaultButton from "../../../../../../components/Buttons/Default";
import { del, post, get } from "../../../../../../utils/helpers/api";

function SkillsModal({ isOpen, toggle, employeeData }) {
  const [newSkill, setNewSkill] = useState("");
  const [skillsData, setSkillsData] = useState(employeeData?.skills || []);
  const [saveLoading, setSaveLoading] = useState(false);

  const saveSkill = async () => {
    const data = await post('/hr/employee-skills/' + employeeData.id + '/store', {
      skill_name: newSkill
    })
    if (data?.success) {
      setNewSkill("");
      getSkillsData();
    }
  };

  const deleteSkill = async (skillId) => {
    const data = await del('/hr/employee-skills/' + employeeData.id + '/delete/'+skillId)
    if (data?.success) {
      getSkillsData();
    }
  };

  const getSkillsData = async () => {
    const data = await get('/hr/employee-skills/' + employeeData.id)
    if (data?.success) {
      setSkillsData(data.skills);
    }
  }

  return(
    <Modal isOpen={isOpen} toggle={toggle} size="md" centered>
      <ModalHeader toggle={toggle}>Skills</ModalHeader>
      <ModalBody>
        <Label>Add a new skill</Label>
        <Row className="g-2">
          <Col md="9" xs="8">
            <Input 
              value={newSkill}
              onChange={(e) => setNewSkill(e.target.value)}
            />
          </Col>
          <Col md="3" xs="4">
            <DefaultButton 
              size="md" 
              block 
              onClick={saveSkill} 
              disabled={!newSkill.trim() || saveLoading}
              loading={saveLoading}
            >
              Add
            </DefaultButton>
          </Col>
        </Row>

        <hr />

        {skillsData.map(
          (s) => (
            <Row key={s.id} className="g-2 mb-1 align-items-center">
              <Col md="9" xs="8">
                {s.skill_name}
              </Col>
              <Col md="3" xs="4" className="text-end">
                <button 
                  type="button" 
                  className="emp-link-btn" 
                  style={{color: "var(--bs-danger)"}} 
                  onClick={() => deleteSkill(s.id)}
                >
                  Delete
                </button>
              </Col>
            </Row>
          )
        )}
      </ModalBody>
      <ModalFooter>
        <Button size="sm" outline onClick={toggle}>
          {t("common.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default SkillsModal;